import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, map, withLatestFrom } from 'rxjs/operators';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';
import AppState from '../../state';
import { hasActiveSubscription } from '../selectors';
import { CloseMenu, NoOp, OpenMenu } from '../../ui/action-creators';

const isWhitelisted = (pathname: string) => {
  if (pathname.startsWith('/release')) {
    if (pathname.endsWith('/streaming-platforms')) {
      return true;
    }
  }
  return false;
};

export const subscriptionGuardEpic = (
  action$: Observable<LocationChangeAction>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(
      ([, state]) =>
        state.subscriptionManager.loaded &&
        !state.subscription.subscriptionCreated
    ),
    map(([action, state]) => {
      const isLockedRoute =
        action.payload.location.pathname.startsWith('/release') ||
        action.payload.location.pathname.startsWith('/merch');

      const payAsYouGo = localStorage.getItem('Trac.PayAsYouGo');

      if (
        isLockedRoute &&
        !isWhitelisted(action.payload.location.pathname) &&
        !payAsYouGo
      ) {
        if (!hasActiveSubscription(state)) {
          return new OpenMenu('DISTRIBUTION_TRIAL');
        }
      }

      if (state.ui.menuOpened === 'DISTRIBUTION_TRIAL') {
        return new CloseMenu(undefined, true);
      }

      return new NoOp();
    })
  );
